import banner from '../../../assets/images/banner.png';
import styles from './BannerPage.module.scss';

export function BannerPage(): React.ReactElement {
  return (
    <div className={styles.bannerPage}>
      <img className={styles.banner} src={banner} alt="Banner" />
    </div>
  );
}
